import { ReactNode } from 'react';

import CustomScrollbar from '../../../../../shared/components/CustomScrollbar/CustomScrollbar';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../../shared/components/Popover/Popover';
import css from './FacetFilterDropdown.css';

interface FacetFilterDropdownProps {
  children: ReactNode;
  count: number;
  label: string;
  className?: string;
}

const FacetFilterDropdown = ({ children, className, count, label }: FacetFilterDropdownProps) => {
  return (
    <Popover>
      <PopoverTrigger className={className}>
        {label} {count > 0 && <span className={css.labelCount}>({count})</span>}
      </PopoverTrigger>
      <PopoverContent className={css.content}>
        <CustomScrollbar className={css.inner} autoHeight autoHeightMax={275}>
          {children}
        </CustomScrollbar>
      </PopoverContent>
    </Popover>
  );
};

export default FacetFilterDropdown;
